import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "google-calendar-integration-on-rnb-plugin"
    }}>{`Google Calendar Integration on RnB Plugin`}</h1>
    <h3 {...{
      "id": "step-1-go-to-google-developers-console"
    }}>{`Step 1: Go To Google Developers Console`}</h3>
    <p>{`To use this integration, go to the `}<a parentName="p" {...{
        "href": "https://console.developers.google.com/project"
      }}>{`Google Developers Console`}</a>{`.`}</p>
    <h3 {...{
      "id": "step-2-create-project-on-google-calendar"
    }}>{`Step 2: Create Project On Google Calendar`}</h3>
    <p>{`Go to: `}<inlineCode parentName="p">{`Projects > Create Project`}</inlineCode>{` button. A popup should appear and ask for Project Name
and Project ID. Enter your preferences.`}</p>
    <p>{`For example`}</p>
    <p><img alt="CreateGcProject.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CreateGcProject.png" /></p>
    <h3 {...{
      "id": "step-3-enable-the-calendar-api"
    }}>{`Step 3: Enable the Calendar API`}</h3>
    <p>{`Once the project has been created, you are in the project folder. Go to the Library link on the left-hand menu. Choose the `}<inlineCode parentName="p">{`Calendar API`}</inlineCode>{`.
`}<img alt="CalendarAPI.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CalendarAPI.png" /></p>
    <p>{`Then click on `}<inlineCode parentName="p">{`Enable`}</inlineCode></p>
    <h3 {...{
      "id": "step-4-create-calendar-credentials"
    }}>{`Step 4: Create Calendar Credentials`}</h3>
    <p>{`This will prompt you to first create credentials. Select `}<inlineCode parentName="p">{`Go to Credentials`}</inlineCode>{`.
`}<img alt="GoToCredentials.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/GoToCredentials.png" /></p>
    <p>{`Choose`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Web Browser (JavaScript)`}</strong>{` as the source`}</li>
      <li parentName="ul">{`Select `}<strong parentName="li">{`User data`}</strong>{` as the data type`}</li>
    </ul>
    <p><img alt="CalendarChoose.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CalendarChoose.png" /></p>
    <p>{`Alternatively, go directly to the`}</p>
    <pre><code parentName="pre" {...{}}>{`API Manager > Project > Credentials page.
`}</code></pre>
    <p>{`There, select Create credentials.`}</p>
    <p><img alt="ClientID.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/ClientID.png" /></p>
    <h3 {...{
      "id": "step-5-insert-new-credentials"
    }}>{`Step 5: Insert new Credentials`}</h3>
    <ul>
      <li parentName="ul">{`Give your Credentials a `}<inlineCode parentName="li">{`Name`}</inlineCode></li>
      <li parentName="ul">{`Leave the `}<inlineCode parentName="li">{`Authorized JavaScript origins`}</inlineCode>{` blank`}</li>
      <li parentName="ul">{`Enter `}<a parentName="li" {...{
          "href": "http://example.com/wc-api/red_rental_google_calendar/as"
        }}>{`http://example.com/wc-api/red_rental_google_calendar/as`}</a>{` the `}<inlineCode parentName="li">{`Authorized Redirect URI`}</inlineCode>{` with example.com being the URL of your web store`}</li>
    </ul>
    <p><img alt="CreateCalendar.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CreateCalendar.png" /></p>
    <h3 {...{
      "id": "step-6-set-up-your-consent-screen"
    }}>{`Step 6: Set up your Consent screen`}</h3>
    <ul>
      <li parentName="ul">{`Your email address is already selected`}</li>
      <li parentName="ul">{`Enter a `}<inlineCode parentName="li">{`Product name shown to users`}</inlineCode></li>
      <li parentName="ul">{`You can also enter extra customization options`}</li>
    </ul>
    <p><img alt="SetupCredentials.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/SetupCredentials.png" /></p>
    <h3 {...{
      "id": "step-7-download-credentials"
    }}>{`Step 7: Download Credentials`}</h3>
    <p>{`Once this is done, download the credentials. Open the `}<inlineCode parentName="p">{`.json`}</inlineCode>{` file to access them. In the file,
you’ll find several things, but these two are needed for the Bookings integration:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`client_id`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`client_secret`}</inlineCode></li>
    </ul>
    <p>{`You can also access these by going to the `}<a parentName="p" {...{
        "href": "https://console.developers.google.com/apis/credentials"
      }}>{`API -> Credentials`}</a>{` page after having created
them. There click on the name of the credentials. You can copy the client ID and secret there.`}</p>
    <p><img alt="DownloadCredentials.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/DownloadCredentials.png" /></p>
    <p>{`Enter these two in your store under`}</p>
    <pre><code parentName="pre" {...{}}>{`WooCommerce > Settings > Integration.
`}</code></pre>
    <h3 {...{
      "id": "step-8-get-calendar-id"
    }}>{`Step 8: Get Calendar ID`}</h3>
    <p>{`Create the calendar you will use in `}<a parentName="p" {...{
        "href": "https://www.google.com/calendar/"
      }}>{`Google Calendar`}</a>{`, if you haven’t already. Then navigate
to My Calendars on the left, and select Calendar Settings.`}</p>
    <p><img alt="CreateGCalendar.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CreateGCalendar.png" /></p>
    <p><img alt="CalendarSettings.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CalendarSettings.png" /></p>
    <p>{`On this screen, there is a section called `}<inlineCode parentName="p">{`Calendar Address`}</inlineCode>{`. Copy the `}<inlineCode parentName="p">{`Calendar ID`}</inlineCode>{`.`}</p>
    <p><img alt="GoogleCalendarID.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/GoogleCalendarID.png" /></p>
    <h3 {...{
      "id": "step-9-integrate-these-credentials-into-woocommerce-settings-panel-in-your-site"
    }}>{`Step 9: Integrate These Credentials into WooCommerce Settings Panel In Your Site`}</h3>
    <p>{`Go to: `}<inlineCode parentName="p">{`WooCommerce > Settings > Integrations`}</inlineCode>{`, and enter the `}<inlineCode parentName="p">{`Calendar ID`}</inlineCode>{`.`}</p>
    <p>{`Finally, select `}<inlineCode parentName="p">{`Save changes`}</inlineCode></p>
    <p><img alt="RnBCSettings.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/RnBCSettings.png" /></p>
    <p>{`Once you’ve entered your credentials and saved your settings, you will be provided with the
option to authorize your account and calendar with Google.`}</p>
    <p>{`Now check your wooCommerce order into your google calendar.`}</p>
    <p><img alt="CalendarOutput.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/CalendarOutput.png" /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      